import React, { useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { Branding, ControlPanel } from "../Header/Header";
import Footer from "../Footer/Footer";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import TokenUtil from "../Utilities/TokenUtil";

import ToastNotification from "../Utilities/ToastNotification";
import "./VenueOnboarding.scss";
import { useAuth } from "../Context/Auth";

function VenueOnboarding() {
  const [validated, setValidated] = useState(false);
  const [isBusy, setIsBusy] = useState(false);
  const [venueName, setVenueName] = useState(null);
  const [toastShow, setToastShow] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  let history = useHistory();
  const location = useLocation();
  const { reCheckAuth } = useAuth();

  const handleChange = (event) => {
    setVenueName(event.target.value);
  };

  function showToastNotification(message) {
    setToastMessage(message);
    setToastShow(true);
  }

  const handleSubmit = (event) => {
    event.preventDefault();
    event.stopPropagation();
    const form = event.currentTarget;
    setValidated(true);
    if (!form.checkValidity()) {
      return;
    }

    setIsBusy(true);
    const payload = {
      venueName: venueName || "",
      timestamp: new Date().getTime(),
      key: "ytvenuepidaccess",
    };

    const encodeToken = TokenUtil.encode(payload);
    let search_params = new URLSearchParams(location.search);
    search_params.set("token", encodeToken);
    history.push({ search: search_params.toString() });
    reCheckAuth();
    showToastNotification(
      "Token has been updated in url, you can copy and save it now."
    );
    setVenueName(null);
    setValidated(false);
    setIsBusy(false);
    setTimeout(() => {
      setToastShow(false);
    }, 5000);
  };

  return (
    <div className="grid-container venue-onboarding">
      <header className="header">
        <Branding />
      </header>

      <main className="tracker">
        <div className="main-content">
          <div className="heading-title border-bottom d-flex justify-content-between">
            <h2 className="no-margin">Venue PID – Token generator</h2>
            <ControlPanel />
          </div>

          <div className="content">
            <Form
              className="venue-form"
              noValidate
              validated={validated}
              onSubmit={handleSubmit}
            >
              <Form.Group controlId="formVenueName">
                <Form.Label>Venue name</Form.Label>
                <Form.Control
                  type="text"
                  value={venueName || ""}
                  onChange={handleChange}
                  placeholder="Enter venue name"
                  required
                />
                <Form.Control.Feedback type="invalid">
                  Please provide a venue name.
                </Form.Control.Feedback>
              </Form.Group>
              <Button
                variant="primary"
                type="submit"
                disabled={isBusy}
                className="text-uppercase text-black submit"
              >
                Generate Token
              </Button>
            </Form>
          </div>
        </div>
        <ToastNotification
          show={toastShow}
          message={toastMessage}
          clickClose={() => setToastShow(false)}
        />
      </main>

      <Footer />
    </div>
  );
}

export default VenueOnboarding;
